module.exports = __webpack_public_path__ + "img/icon3.632b7a2e.png";